import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LTR_ISOLATE_ATTRS } from "@/lib/blog/locale-options";

interface EnlargeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  src: string;
  alt: string;
  hash: string;
}

/**
 * A variant at full size (Q27).
 *
 * A 120px thumbnail cannot answer "is the app in this shot actually in Finnish",
 * which is the only question the reviewer is here to answer.
 */
export function EnlargeDialog({ open, onOpenChange, title, src, alt, hash }: EnlargeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl" data-testid="enlarge-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <img src={src} alt={alt} className="max-h-[70vh] w-full object-contain" />
        <p className="font-mono text-xs text-muted-foreground" {...LTR_ISOLATE_ATTRS}>
          {hash}
        </p>
      </DialogContent>
    </Dialog>
  );
}
